import * as React from "react";
import { IAuthenticationStatus } from "../authentication/IAuthenticationStatus";
import { IAuthenticationClient } from "../authentication/Authentication";
import { Subscription } from "../authentication/Observable";

export interface IAuthContext {
    client: IAuthenticationClient;
    status: IAuthenticationStatus;
}
// TypeScripts compiler complains, as providing a default value is necessary, so we set the initial context to null
// by overriding the type check, then this.context will
export const AuthContext = React.createContext<IAuthContext>(null as any);

// AuthContainer is used so our context has state and knows when we are logged in or not
class AuthContainer extends React.Component<
    { client: IAuthenticationClient; children?: React.ReactNode },
    IAuthContext
> {
    private readonly subscription: Subscription;

    constructor(props: { client: IAuthenticationClient }) {
        super(props);

        this.state = {
            client: props.client,
            status: props.client.GetStatus(),
        };

        this.subscription = props.client.Status.subscribe(this.statusUpdated);
    }

    private statusUpdated = (value: IAuthenticationStatus) => {
        this.setState({
            status: value,
        });
    };

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    render() {
        return (
            <AuthContext.Provider value={this.state}>
                {this.props.children}
            </AuthContext.Provider>
        );
    }
}

export default AuthContainer;
